define('rebrush/components/blocks/landingpages/router/video',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'lodash'
], function(
    $,
    Component,
    BEM,
    _
) {
    var BLOCK_NAME = 'lp-router-video';

    function Video(block) {
        this.block = BEM.block(block);
        this.$refs = {
            overlay: this.block.getElements('overlay'),
            video: this.block.getElements('video')
        };

        this.bindEvents();
    }

    Video.prototype = {
        bindEvents: function() {
            this.$refs.overlay.on('click', _.bind(this.play, this));
            this.$refs.video.on('ended', _.bind(this.reset, this));
            this.$refs.video.on('click', _.bind(this.pause, this));
        },

        play: function() {
            this.$refs.overlay.hide();
            this.$refs.video.get(0).play();
        },

        pause: function() {
            this.$refs.overlay.show();
            this.$refs.video.get(0).pause();
        },

        reset: function() {
            this.$refs.overlay.show();
        }
    };

    return Component.create({
        $init: function() {
            BEM.block(BLOCK_NAME).each(function() {
                new Video(this);
            });
        }
    });
});
